(() => {
  const initialized = new WeakSet();
  const money = (value) =>
    new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value);
  const init = (root) => {
    if (initialized.has(root)) return;
    initialized.add(root);
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.querySelectorAll('[data-rvp-gallery]').forEach((gallery) => {
      const image = gallery.querySelector('[data-rvp-gallery-image]'),
        count = gallery.querySelector('[data-rvp-gallery-count]'),
        name = gallery.querySelector('[data-rvp-gallery-name]'),
        description = gallery.querySelector('[data-rvp-gallery-description]'),
        thumbs = [...gallery.querySelectorAll('[data-rvp-gallery-thumb]')],
        stage = gallery.querySelector('.rvp-gallery__stage');
      let active = 0,
        request = 0;
      const preloads = new Map();
      const preload = (src) => {
        if (preloads.has(src)) return preloads.get(src).ready;
        const loader = new Image();
        loader.decoding = 'async';
        const ready = new Promise((resolve) => {
          loader.addEventListener('load', () => {
            Promise.resolve(loader.decode?.()).catch(() => {}).then(() => resolve(true));
          }, { once: true });
          loader.addEventListener('error', () => resolve(false), { once: true });
        });
        preloads.set(src, { loader, ready });
        loader.src = src;
        return ready;
      };
      if (!navigator.connection?.saveData) {
        const observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          thumbs.forEach((thumb) => preload(thumb.dataset.src));
        }, { rootMargin: '125% 0px' });
        observer.observe(gallery);
      }
      const show = (next) => {
        active = (next + thumbs.length) % thumbs.length;
        const currentRequest = ++request;
        const button = thumbs[active],
          swap = () => {
            if (currentRequest !== request) return;
            image.src = button.dataset.src;
            image.alt = `${root.dataset.model.toUpperCase()} ${button.dataset.title.toLowerCase()}`;
            count.textContent = `${String(active + 1).padStart(2, '0')} / ${String(thumbs.length).padStart(2, '0')}`;
            name.textContent = button.dataset.title;
            description.textContent = button.dataset.description;
            thumbs.forEach((thumb, index) => thumb.setAttribute('aria-current', String(index === active)));
            button.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
            image.classList.remove('is-changing');
            gallery.dataset.galleryIndex = String(active);
          };
        image.classList.add('is-changing');
        Promise.all([
          preload(button.dataset.src),
          reduced ? Promise.resolve() : new Promise((resolve) => setTimeout(resolve, 120)),
        ]).then(([ready]) => {
          if (currentRequest !== request) return;
          if (ready) swap();
          else image.classList.remove('is-changing');
        });
      };
      thumbs.forEach((button) => button.addEventListener('click', () => show(Number(button.dataset.rvpGalleryThumb))));
      gallery.querySelector('[data-rvp-gallery-prev]')?.addEventListener('click', () => show(active - 1));
      gallery.querySelector('[data-rvp-gallery-next]')?.addEventListener('click', () => show(active + 1));
      stage?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          show(active + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      let touchX = 0;
      stage?.addEventListener(
        'touchstart',
        (event) => {
          touchX = event.changedTouches[0].clientX;
        },
        { passive: true },
      );
      stage?.addEventListener(
        'touchend',
        (event) => {
          const delta = event.changedTouches[0].clientX - touchX;
          if (Math.abs(delta) > 45) show(active + (delta < 0 ? 1 : -1));
        },
        { passive: true },
      );
    });
    root.querySelectorAll('[data-rvp-finance]').forEach((calculator) => {
      const base = Number(root.dataset.basePrice),
        form = calculator.querySelector('form'),
        recovery = calculator.querySelector('[data-rvp-recovery]'),
        down = calculator.querySelector('[data-rvp-down]'),
        term = calculator.querySelector('[data-rvp-term]'),
        apr = calculator.querySelector('[data-rvp-apr]');
      const update = () => {
        const total = base + (recovery.checked ? 20000 : 0),
          principal = Math.max(0, total - Number(down.value)),
          months = Number(term.value),
          rate = Number(apr.value) / 100 / 12,
          payment = rate ? (principal * rate) / (1 - Math.pow(1 + rate, -months)) : principal / months;
        calculator.querySelector('[data-rvp-down-output]').value = money(Number(down.value));
        calculator.querySelector('[data-rvp-term-output]').value = `${months} ${calculator.dataset.monthSuffix}`;
        calculator.querySelector('[data-rvp-apr-output]').value = `${Number(apr.value).toFixed(2)}%`;
        calculator.querySelector('[data-rvp-total]').textContent = money(total);
        calculator.querySelector('[data-rvp-payment]').value = `${money(Math.round(payment))}${calculator.dataset.paymentSuffix}`;
        calculator.dataset.payment = String(Math.round(payment));
      };
      form?.addEventListener('input', update);
      update();
    });
  };
  document.querySelectorAll('[data-rvp-root]').forEach(init);
  document.addEventListener('shopify:section:load', (event) =>
    event.target.querySelectorAll('[data-rvp-root]').forEach(init),
  );
})();
